import React, { useState } from "react";
import DoctorLayout from "../../Layouts/Doctor/DoctorLayout";
import { useNavigate } from "react-router-dom";

export default function DoctorMyAppointments() {

    const navigate = useNavigate();

    const [filters, setFilters] = useState({
        patientName: "",
        consultationType: "New",
        status: "",
        date: "",
    });

    const appointments = [
        {
            patient: "Ravi Kumar",
            age: 45,
            gender: "Male",
            date: "12 Aug 2026",
            time: "10:30 AM",
            status: "Waiting",
        },
        {
            patient: "Arjun Das",
            age: 37,
            gender: "Female",
            date: "12 May 2026",
            time: "10:30 AM",
            status: "Started",
        },
        {
            patient: "Meena",
            age: 32,
            gender: "Female",
            date: "12 Aug 2026",
            time: "11:00 AM",
            status: "Completed",
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = (e) => {
        e.preventDefault();
        console.log(filters);
    };

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "waiting":
                return "badge badge-light-primary text-primary fw-bold px-3 py-2 rounded-pill";
            case "started":
                return "badge badge-light-warning text-warning fw-bold px-3 py-2 rounded-pill";
            case "completed":
                return "badge badge-light-success text-success fw-bold px-3 py-2 rounded-pill";
            default:
                return "badge badge-light-secondary text-secondary fw-bold px-3 py-2 rounded-pill";
        }
    };

    return (
        <DoctorLayout>
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border-0 rounded-4 shadow-sm">
                        <div className="card-header bg-white border-0 pt-4 pb-0">
                            <div className="w-100">
                                <div className="bg-light-primary text-primary fw-bold px-4 py-3 rounded-3 fs-7 text-uppercase">
                                    Filter Parameters
                                </div>
                            </div>
                        </div>

                        <div className="card-body p-4">
                            <form onSubmit={handleSearch}>
                                <div className="row g-3 align-items-end">
                                    <div className="col-12 col-md-6 col-xl-2">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Patient Name
                                        </label>
                                        <input
                                            type="text"
                                            name="patientName"
                                            className="form-control"
                                            placeholder="Search by Patient Name or Phone"
                                            value={filters.patientName}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-2">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Consultation Type
                                        </label>
                                        <select
                                            name="consultationType"
                                            className="form-select"
                                            value={filters.consultationType}
                                            onChange={handleChange}
                                        >
                                            <option value="New">New</option>
                                            <option value="Follow-up">Follow-up</option>
                                            <option value="Teleconsultation">Teleconsultation</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-2">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Status
                                        </label>
                                        <select
                                            name="status"
                                            className="form-select"
                                            value={filters.status}
                                            onChange={handleChange}
                                        >
                                            <option value="">All Status</option>
                                            <option value="Waiting">Waiting</option>
                                            <option value="Started">Started</option>
                                            <option value="Completed">Completed</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-2">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Date
                                        </label>
                                        <input
                                            type="date"
                                            name="date"
                                            className="form-control"
                                            value={filters.date}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-sm px-4 w-100"
                                        >
                                            <i className="bi bi-search me-2"></i>
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="card border-0 rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed mb-0">
                                    <thead>
                                        <tr className="fw-bold text-dark" style={{ backgroundColor: "#dbe8fb" }}>
                                            <th className="ps-5">Patient</th>
                                            <th>Age</th>
                                            <th>Gender</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Status</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody className="fw-semibold text-gray-700">
                                        {appointments.map((item, index) => (
                                            <tr key={index}>
                                                <td className="ps-5">{item.patient}</td>
                                                <td>{item.age}</td>
                                                <td>{item.gender}</td>
                                                <td>{item.date}</td>
                                                <td>{item.time}</td>
                                                <td>
                                                    <span className={getStatusBadge(item.status)}>
                                                        {item.status}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <button
                                                        className="btn btn-primary btn-sm px-3"
                                                        onClick={() => navigate("/doctor/consultation", { state: item })}
                                                    >
                                                        <i className="bi bi-eye me-1"></i>
                                                        Details
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}

                                        {appointments.length === 0 && (
                                            <tr>
                                                <td colSpan="7" className="text-center py-10 text-muted fw-semibold">
                                                    No appointments found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DoctorLayout>
    );
}
